export const LeftArrowModalIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6992 7.875H4.97422L11.2742 1.575L9.69922 0L0.699219 9L9.69922 18L11.2742 16.425L4.97422 10.125H18.6992V7.875Z"
        fill="#373737"
      />
    </svg>
  );
};
